export type CertificationStatus =
  | "PENDING"
  | "IN_REVIEW"
  | "WAITING_FOR_USER"
  | "CERTIFIED"
  | "CERTIFIED_WITH_RESERVATIONS"
  | "CORRECTED"
  | "DECLINED"
  | "CANCELLED";

export const TERMINAL_STATUSES: CertificationStatus[] = [
  "CERTIFIED",
  "CERTIFIED_WITH_RESERVATIONS",
  "CORRECTED",
  "DECLINED",
  "CANCELLED",
];

export const IN_PROGRESS_STATUSES: CertificationStatus[] = [
  "PENDING",
  "IN_REVIEW",
  "WAITING_FOR_USER",
];

// Décisions finales possibles pour l'expert (hors annulation).
export const DECISION_STATUSES: CertificationStatus[] = [
  "CERTIFIED",
  "CERTIFIED_WITH_RESERVATIONS",
  "CORRECTED",
  "DECLINED",
];

export function isTerminalStatus(status?: CertificationStatus | null): boolean {
  return !!status && TERMINAL_STATUSES.includes(status);
}

// Statuts dont la décision requiert un texte obligatoire (réserves / correction / motif).
export function statusRequiresText(status: CertificationStatus): boolean {
  return (
    status === "CERTIFIED_WITH_RESERVATIONS" ||
    status === "CORRECTED" ||
    status === "DECLINED"
  );
}

export function getStatusLabelKey(status: CertificationStatus): string {
  return `CERTIFICATION_STATUS_${status}`;
}
